import {EndGameData} from '@colonist/game-base-types'
import {TranslationObject} from '@colonist/i18n'

export enum RankedUserStateType {
    Placement,
    Ranked,
    RankedLocked,
}

export abstract class BaseRankedUserState {
    abstract readonly type: RankedUserStateType

    abstract getEndGameScreenUpdateText(): TranslationObject
    abstract getEndGameData(): EndGameData
    abstract getFindGamePopupStatusText(): TranslationObject
}
